/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/engine-is-deno.js
// module id = 457
// module chunks = 142